import { getExploreName } from '../utils/platform';

export const devConfig = {
  sdkKey: 'B2ZICBK8QAyQKP7-Y5YS7w',
  sdkSecret: 'hXNiEcCJI5eTYjlDr8uyAjQ06ScB35B7lHbH',
  webEndpoint: 'zoom.us', // zfg use www.zoomgov.com
  topic: 'Test',
  name: `${getExploreName()}-${Math.floor(Math.random() * 1000)}`,
  password: '',
  signature: '',
  sessionKey: 'eyJhbGciOiJIUzI1NiJ9.eyJhdWQiOm51bGwsImlzcyI6IkIyWklDQks4UUF5UUtQNy1ZNVlTN3ciLCJleHAiOjE2NTc5NTQ4MDAsImlhdCI6MTYzNzEzOTg2Nn0.oxAs3J53OLP5dc_4rqp6xV5oGSmhZAMlBWyCiwIE1k0',
  userIdentity: 'git remote get-url origin',
  // The user role. 1 to specify host or co-host. 0 to specify participant, Participants can join before the host. The session is started when the first user joins. Be sure to use a number type.
  role: 0
};
